__turbopack_context__.v({
  "button": "QEnZoW_button",
  "icon": "QEnZoW_icon",
});
